import request from '@/utils/http';
// 获取操作指南
export const getInfos = (params) => {
    return request({
        url: `/api-sn/config/guideManages`,
        method: 'post',
        data: params
    });
};